import { Component, OnDestroy, OnInit } from '@angular/core';
import { CategoryService } from '../../../services/category.service';
import { AuthenticationService, EntityService, ToolbarService } from '@kaiser-software/chassis-core';
import { Subscription } from 'rxjs';
import { __ } from '@kaiser-software/chassis-localization';

@Component({
    selector: 'app-observation-categories-index',
    templateUrl: 'index.component.html',
    styleUrls: ['index.component.scss']
})
export class CategoriesIndexComponent implements OnInit, OnDestroy {

    protected title = 'Observation categories';

    protected routePrefix = 'observation-categories';

    protected pluginPrefix = 'eyewatch-observation-categories';

    protected table;

    protected subscription = new Subscription();

    constructor(
        protected observationCategoriesApi: CategoryService,
        protected authenticationService: AuthenticationService,
        protected entityService: EntityService,
        protected toolbarService: ToolbarService,
    ) {
        //
    }

    public ngOnInit(): void {
        this.createDatatable();
    }

    protected createDatatable(): void {
        this.subscription.add(
            this.authenticationService.user$
                .subscribe((user) => {
                    this.table = {
                        service: this.observationCategoriesApi,
                        order: false,
                        buttons: (user.hasRole('admin')
                            || user.hasRole('customer'))
                            ? ['excel']
                            : [],
                        columns: [{
                            name: 'id', data: 'id', title: __('Id'), searchable: true, visible: true,
                            sortable: false, filter: {filter_type: 'text', filter_delay: 1000},
                        }, {
                            name: 'title', data: 'title', title: __('Title'), searchable: true, visible: true,
                            sortable: false, filter: {filter_type: 'text', filter_delay: 1000}
                        }],
                    };
                })
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/pages/categories/index/index.component.ts